/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

const paymentApi = require('../services/payment-api.service');
const rootScope = require('../services/root-scope.service');
const { isValidListURL } = require('../services/config.service');

module.exports = function (callback) {
    let listUrl = rootScope.getListUrl();
    if (!isValidListURL(listUrl)) listUrl = '';

    rootScope.resetSelectedNetwork();
    rootScope.removeSpecialButtons();
    paymentApi.listRequest(listUrl, rootScope.getListHandler(), callback);
};
